var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRu = function SvgRu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ru_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M.328 4.894h16v7.5h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M.328 11.394h16v5.25h-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    d: "M.328.644h16v5.25h-16z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ru_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 0.328,
    y: 0.644,
    fill: "#fff",
    rx: 4
  })))));
};
export { SvgRu as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBmaWxsPSIjMDA1MkI0IiBkPSJNLjMyOCA0Ljg5NGgxNnY3LjVoLTE2eiIvPjxwYXRoIGZpbGw9IiNEODAwMjciIGQ9Ik0uMzI4IDExLjM5NGgxNnY1LjI1aC0xNnoiLz48cGF0aCBmaWxsPSIjRUVFIiBkPSJNLjMyOC42NDRoMTZ2NS4yNWgtMTZ6Ii8+PC9nPjxkZWZzPjxjbGlwUGF0aCBpZD0iYSI+PHJlY3QgeD0iLjMyOCIgeT0iLjY0NCIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iNCIgZmlsbD0iI2ZmZiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==";